import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("xandi_cookie_ok")) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("xandi_cookie_ok", "1");
    setVisible(false);
    try {
      window.dispatchEvent(new CustomEvent("xandi:cookies-accepted"));
    } catch (e) {}
  };

  if (!visible) return null;

  return (
    <div className="cookie" data-testid="cookie-banner">
      <p>
        We use cookies to improve your experience and for analytics, in line with Jamaica's Data
        Protection Act (2020). <Link to="/privacy">Learn more</Link>.
      </p>
      <button
        type="button"
        className="btn btn-ghost"
        style={{ padding: "10px 20px" }}
        onClick={accept}
        data-testid="cookie-accept-btn"
      >
        Got it
      </button>
    </div>
  );
};

export default CookieBanner;
